import React from "react";
import "./Validations.scss";
import { withDefaults } from "../../utils/withDefaults";

export interface ValidationsProps {
  validations?: string[];
}

export default function Validations(incomingProps: ValidationsProps) {
  const props = withDefaults(incomingProps, validationsDefaultProps);

  return props.validations.length > 0
    ? props.validations.map((validation, index) => (
        <span key={index} className="validation-error">
          {validation}
        </span>
      ))
    : null;
}

const validationsDefaultProps = {
  validations: [] as string[]
};
